import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'showPropertyArraySelectAllButton',
})
export class ShowPropertyArraySelectAllButtonPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): boolean {
    const optionsLength = properties.getEnumValues(controlName).length;
    const maxItems = properties.getField(controlName).maxItems;
    return optionsLength > 3 && !maxItems;
  }
}
